export const advanceSearchInitialState: any = {
  FirstName: "",
  LastName: "",
  IsVisitCanBe: false,
  IsVisitCantBe: false,
  VisitStartDate: "",
  VisitEndDate: "",
  IsLastVisitCanBe: false,
  IsLatsVisitCantBe: false,
  LastVisitStartDate: "",
  LastVisitEndDate: "",
  Phone1: "",
  Dob: "",
  EndDOB: "",
  AgeGroup: -1,
  AgreementId: -1,
  IsMale: false,
  IsFemale: false,
  IsNotSet: false,
  IsReservation: "",
  IsNominationFeeCanBe: false,
  IsNominationFeeCantBe: false,
  IsRefererCanBe: false,
  IsRefererCantBe: false,
  IsDMYes: false,
  IsDMNo: false,
  NumberOfVisit: "",
  NumberOfVisitTo: "",
  ReasonOfVisiting: -1
};
